// Open a URL so the user can return to the app afterwards.
// In a regular web browser, '_blank' opens a new tab and works fine.
// Inside a Capacitor WebView (iOS/Android), the correct fix is the
// @capacitor/browser plugin (Browser.open), which opens a Chrome
// Custom Tab on Android / SFSafariViewController on iOS — both return
// the user to the wrapped app cleanly. We call it via the runtime-
// injected window.Capacitor.Plugins.Browser global so this React app
// does NOT need to import @capacitor/browser (it's installed in the
// wrapper project at /mnt/c/HireIt/hireit/, not here).
//
// Fallback chain:
//   1. Native + Browser plugin registered → Browser.open({ url })
//   2. Native shell but plugin not yet present (e.g. before the Android
//      app is rebuilt with @capacitor/browser) → window.open(url, '_system').
//      Preserves the prior Android behaviour as a safety net; iOS WKWebView
//      will ignore '_system' but there's no better fallback in that gap.
//   3. Desktop / mobile web → window.open(url, '_blank').
export async function openExternal(url) {
  const cap = typeof window !== 'undefined' ? window.Capacitor : null
  if (cap?.Plugins?.Browser) {
    await cap.Plugins.Browser.open({ url })
  } else if (cap?.isNativePlatform?.()) {
    window.open(url, '_system')
  } else {
    window.open(url, '_blank')
  }
}
